import { ref, readonly } from 'vue'
import type { Toast, ToastType } from '@/types/toast'

const toasts = ref<Toast[]>([])
let toastId = 0

function addToast(message: string, type: ToastType = 'info', duration: number = 3000) {
  const id = ++toastId
  const toast: Toast = { id, message, type, duration }
  toasts.value.push(toast)

  if (duration > 0) {
    setTimeout(() => {
      removeToast(id)
    }, duration)
  }

  return id
}

function removeToast(id: number) {
  const index = toasts.value.findIndex(t => t.id === id)
  if (index !== -1) {
    toasts.value.splice(index, 1)
  }
}

function success(message: string, duration?: number) {
  return addToast(message, 'success', duration)
}

function error(message: string, duration?: number) {
  return addToast(message, 'error', duration ?? 4000)
}

function info(message: string, duration?: number) {
  return addToast(message, 'info', duration)
}

function warning(message: string, duration?: number) {
  return addToast(message, 'warning', duration)
}

export function useToast() {
  return {
    toasts: readonly(toasts),
    removeToast,
    success,
    error,
    info,
    warning
  }
}
